import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-category-book-list',
  templateUrl: './category-book-list.component.html',
  styleUrls: ['./category-book-list.component.scss']
})
export class CategoryBookListComponent implements OnInit {
  public loadMoreShow:boolean =false;
  public bookLists:Array<any>=[];
  public topicLists:Array<any>=[];
  public difficultyLevelIds:Array<any>=[];
  public difficultyLevelLists:Array<any>=[];
  public gradeLevelIds:Array<any>=[];
  public gradeLevelLists:Array<any>=[];
  public selectedLetter = "";
  public filterType = "T";
  public dictionaryBookList:Array<any> = [];
  public searchParams={
    categoryType:'',
  };
  public booksearchKeysList:Array<any> = [];
  public filteredBookSearchKeysList: Array<any> = [];
  public categoryName: any = "";
  language: string = localStorage.getItem('_lang');
  constructor(
    public translate: TranslateService,
    private cService: CommonService,
    private httpService: HttpRequestService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
      this.cService.activelang.subscribe((lang) => {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
  }

  ngOnInit() {
    this.translate.get(['BROWSE_BOOK_SEARCH_KEYS']).subscribe((tData)=>{
      this.booksearchKeysList = tData['BROWSE_BOOK_SEARCH_KEYS'];
    });
    this.activatedRoute.params.subscribe((paramData)=>{
        this.filterType = "T";
        //console.log(this.filterType,"filterType");
        this.searchParams.categoryType =paramData.id;
        this.getBooks();
    });
  }
  public getBooks(){
    this.httpService.setModule('action').post('category_book_list',this.searchParams).subscribe((response) => {
        if (response.status=='success') {
          this.categoryName= response.data.category_details.local[0].name;
          this.bookLists = response.data.book_list_data;
          this.topicLists = response.data.book_topics_data;
          this.bookLists.sort(function(a, b){
              if(a.local[0].title < b.local[0].title) { return -1; }
              if(a.local[0].title > b.local[0].title) { return 1; }
              return 0;
          });
          //console.log(this.bookLists);
          if(this.searchParams.categoryType=='9'){
            this.bookLists.forEach((el)=>{
                  if(!this.difficultyLevelIds.includes(el.difficulty_level.id)){
                    this.difficultyLevelIds.push(el.difficulty_level.id)
                    this.difficultyLevelLists.push(el.difficulty_level);
                  }
                  if(!this.gradeLevelIds.includes(el.grade_level.id)){
                    this.gradeLevelIds.push(el.grade_level.id)
                    this.gradeLevelLists.push(el.grade_level);
                  }
            });
            // console.log(this.difficultyLevelLists,"difficulty Level");
            // console.log(this.gradeLevelLists,"grade Level");
          }

          this.convertToDictionaryFormat();

        }
        if (response.status=='error') {
          this.toastr.error( response.data,'Login');
        }
    }, (error) => {
      console.log(error);
    });
  }

  public convertToDictionaryFormat(){
    let data = this.bookLists.reduce((r, e) => {
      let name:any;
      if(this.filterType == "T"){
        name= e.local[0].title[0]
      } else if(this.filterType == "A") {
        name= e.author[0].local[0].name[0]
      } else if(this.filterType == "TO") {
        name= e.topic[0].local[0].title
      } else if(this.filterType == "D") {
        name= e.difficulty_level.local[0].name
      } else if(this.filterType == "G") {
        name= e.grade_level.local[0].name
      }
      let group = name;
      if(!r[group]) r[group] = {group, children: [e]}
      else r[group].children.push(e);
      return r;
    }, {})
    // since data at this point is an object, to get array of values
    // we use Object.values method
    this.dictionaryBookList = Object.values(data);
    this.dictionaryBookList.filter(x => {

      if(this.booksearchKeysList.includes(x.group)) {
        this.filteredBookSearchKeysList.push(x.group);
      }

      // return !this.booksearchKeysList.includes(x.group)
    });
    // console.log(this.filteredBookSearchKeysList);
  }
  public setBrowseChar(val){
    this.selectedLetter = val.toUpperCase( );
  }

  public setFilterType (val){
    this.filterType = val;
    if(val == "T"){
      this.bookLists.sort(function(a, b){
          if(a.local[0].title < b.local[0].title) { return -1; }
          if(a.local[0].title > b.local[0].title) { return 1; }
          return 0;
      });
      this.convertToDictionaryFormat();
    } else if(val == "A"){
      this.bookLists.sort(function(a, b){
          if(a.author[0].local[0].name < b.author[0].local[0].name) { return -1; }
          if(a.author[0].local[0].name > b.author[0].local[0].name) { return 1; }
          return 0;
      });
      this.convertToDictionaryFormat();
    } else if(val == "TO"){
      this.bookLists.sort(function(a, b){
          if(a.topic[0].local[0].name < b.topic[0].local[0].name) { return -1; }
          if(a.topic[0].local[0].name > b.topic[0].local[0].name) { return 1; }
          return 0;
      });
      this.convertToDictionaryFormat();
    } else if(val == "D"){
      this.bookLists.sort(function(a, b){
          if(a.difficulty_level.local[0].name < b.difficulty_level.local[0].name) { return -1; }
          if(a.difficulty_level.local[0].name > b.difficulty_level.local[0].name) { return 1; }
          return 0;
      });
      this.convertToDictionaryFormat();
    } else if(val == "G"){
      this.bookLists.sort(function(a, b){
          if(a.grade_level.local[0].name < b.grade_level.local[0].name) { return -1; }
          if(a.grade_level.local[0].name > b.grade_level.local[0].name) { return 1; }
          return 0;
      });
      this.convertToDictionaryFormat();
    }
  }

  public viewBookMore(books){
    console.log(books)
    localStorage.setItem('viewMoreBook',JSON.stringify(books));
    this.router.navigate(['/view-more-book']);
  }

}
